/** Shared auth form field tokens (no component imports — avoids circular deps). */

export const authFieldBaseClass =
  'h-[60px] max-w-full rounded-[20px] !border-2 !border-transparent !bg-[#F1F1F1] px-[20px] text-[16px] font-normal leading-normal text-[#535353] shadow-none outline-none placeholder:text-[#989898] focus:!border-[#2B7E20] focus:!ring-0 dark:!bg-[#1d2128] dark:text-[#f3f4f6] dark:placeholder:text-[#7d8794]';



export const authFieldClass = `${authFieldBaseClass} w-[350px]`;

export const authFieldHalfClass = `${authFieldBaseClass} w-[163px]`;



/** Red X on auth cards and country panel — sits just outside top-right corner. */

export const authActionOutsetClass = 'absolute -right-[25px] -top-[25px]';

